function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "10",
  height: "10",
  viewBox: "0 0 10 10",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M5.548 4.5H8.99a.51.51 0 01.51.5c0 .276-.222.5-.51.5H5.548v3.607a.51.51 0 01-.5.51.501.501 0 01-.5-.51V5.5H1.01A.51.51 0 01.5 5c0-.276.222-.5.51-.5h3.538V1.126a.51.51 0 01.5-.51c.276 0 .5.223.5.51V4.5z",
  fill: "currentColor",
  fillRule: "evenodd"
})));